/**
 *  The purpose of this method is to check if
 *  a degree has changed or not
 *
 *  @returns Boolean - true indicates it as changed
 */

export default (degree, oldDegrees = []) => {
    const id = degree.id;
    if (!id) {
        return true; // No id
    }

    const oldDegree = oldDegrees.find(d => d.id === id);
    if (!oldDegree) {
        return false; // Does not exist
    }

    const hasChanged =
        degree.name !== oldDegree.name ||
        degree.start !== oldDegree.start ||
        degree.end !== oldDegree.end ||
        degree.field_id !== oldDegree.field_id ||
        degree.level_id !== oldDegree.level_id ||
        degree.school_id !== oldDegree.school_id;
    return hasChanged;
};
